// extracted by mini-css-extract-plugin
export default {"listItem":"Resume_listItem__MCU5L","listContainer":"Resume_listContainer__1c88X"};